import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserDataService } from 'src/app/modules/core/services/parameter';
import { ModalLogoutComponent } from 'src/app/modules/core/components/modal-logout/modal-logout.component';
import { IModalLogout } from 'src/app/modules/core/interfaces/logout';

@Component({
  selector: 'app-navbar-option-profile',
  templateUrl: './navbar-option-profile.component.html',
  styleUrls: ['./navbar-option-profile.component.scss'],
})
export class NavbarOptionProfileComponent implements OnInit {
  public displayName: string;
  public showTooltip: boolean;
  public errorMsg: string;

  constructor(private modalService: NgbModal, private readonly userDataService: UserDataService) {
    this.showTooltip = false;
    this.errorMsg = '';
  }

  /**
   * Init app
   */
  public ngOnInit(): void {
    this.displayName = this.userDataService.get().firstName;
  }

  /**
   * Function to logout user
   */
  public logout(): void {
    const componentRef = this.modalService.open(ModalLogoutComponent, { centered: true });

    const modalLogout: IModalLogout = {
      title: 'logout',
      message: 'logout_from',
      messageParam: this.userDataService.fullName(),
      actionButtonText: 'exit',
      cancelButtonText: 'cancel',
      imageKey: 'logout',
      imageType: 'icon',
      darkTheme: true,
    };
    componentRef.componentInstance.option = modalLogout;
  }
}
